import React from 'react';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Limit90Alert = ({ isFromPartner, partnerEmail, meterNames = [], onClose }) => {
  const meterLabel = meterNames.length ? meterNames.join(', ') : 'one or more meters';

  return (
    <div style={{ display: 'flex', alignItems: 'center', minHeight: '40px', position: 'relative' }}>
      <Typography
        variant="body1"
        sx={{
          fontSize: '1rem',
          fontWeight: 'bold',
          textAlign: 'center',
          paddingRight: '50px', // Add padding to prevent text overlap with close button
        }}
      >
        {isFromPartner
          ? `You have reached 90% of your invoice usage limit for ${meterLabel} in the current subscription period. Please reach out to ${partnerEmail}.`
          : `You have reached 90% of your invoice usage limit for ${meterLabel} in the current subscription period.`}
      </Typography>
      <IconButton
        aria-label="close"
        color="inherit"
        size="small"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

export default Limit90Alert;
